import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=56531daa&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56531daa')) {
      api.createRecord('56531daa', component.options)
    } else {
      api.reload('56531daa', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=56531daa&", function () {
      api.rerender('56531daa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2s41RxwjEZx2w/JS/comp/openstreetmap.vue"
export default component.exports